import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Intake from './pages/Intake';
import Methodology from './pages/Methodology';
import Admin from './pages/Admin';
import ReportViewer from './pages/ReportViewer';
import SampleReport from './pages/SampleReport';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';

export default function App() {
  return (
    <div className="grain min-h-screen relative">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/methodology" element={<Methodology />} />
        <Route path="/intake" element={<Intake />} />
        <Route path="/sample" element={<SampleReport />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="/report/:id" element={<ReportViewer />} />
      </Routes>
    </div>
  );
}
